import React from "react"
import bug from "../../../assets/images/flags/bug-icon.png"
import Suggestion from "../../../assets/images/flags/sugg-icon.png"
import moment from "moment"
import { ticketStatus } from "utils/common-options"

export const developerTicketColumn = (onReply, onChangeStatus, onStartTimer, isRunning, currentTaskId, onAddHours) => [
    {
        Header: "ID",
        accessor: "id",
        title: "ID",
        isInfoIcon: false,
        isShortIcon: true,
        className: "s_id",
    },
    {
        Header: "Type",
        title: "type_name",
        accessor: "type_name",
        isInfoIcon: false,
        isShortIcon: true,
        className: "stype_name_box",
        Cell: cellProps => {
            const icon = cellProps.row?.original?.type == 0 ? bug : Suggestion
            return (
                <div className="text-center d-flex gap-1 flex-wrap justify-content-center align-items-center type_img">
                    {icon != null ? (
                        <img src={icon} alt="" className="img-fluid assignee-img ms-2" ></img>
                    ) : '-'}
                </div>
            )
        },
    },
    {
        Header: "Title",
        title: "Task Name",
        accessor: "subject",
        isInfoIcon: false,
        isShortIcon: true,
        className: "stask_name_box",
    },
    {
        Header: "Status",
        title: "Status",
        accessor: "status_col",
        isInfoIcon: false,
        isShortIcon: true,
        className: "sstatus_box",
        Cell: cellProps => {

            return (
                <div className="custom-select-wrapper">
                    <select
                        className={`form-select custom-select`}
                        value={cellProps.row?.original?.status}
                        onChange={(e) => onChangeStatus(e.target.value, cellProps.row?.original?.id)}
                    >
                        {ticketStatus?.map((obj, i) => {
                            return (
                                <option value={obj?.value} className="" key={i}>
                                    {obj?.label}
                                </option>
                            )
                        })}
                    </select>
                </div>
            )
        },
    },
    {
        Header: "Priority",
        title: "Priority",
        accessor: "priority",
        isInfoIcon: false,
        isShortIcon: true,
        className: "prioritys_col_box ",
        Cell: cellProps => {
            const cellValue = cellProps.value
            let style = {}

            if (cellValue === "High") {
                style = { color: "red" }
            } else if (cellValue === "Medium") {
                style = { color: "blue" }
            } else if (cellValue === "Low") {
                style = { color: "green" }
            }

            return (
                <div style={style}>
                    {cellValue}
                </div>
            )
        },
    },
    {
        Header: "Created At",
        title: "created at",
        accessor: "created_at",
        isInfoIcon: false,
        isShortIcon: true,
        className: "screated_at_col-box",
        Cell: cellProps => {
            return (
                <div>{moment(cellProps?.row?.original?.created_at).format('DD-MM-YYYY')}</div>
            )
        }
    },
    {
        Header: "Last Reply",
        title: "Last Reply",
        accessor: "last_reply_col",
        isInfoIcon: false,
        isShortIcon: true,
        className: "slast_reply_col-box ",
        Cell: cellProps => {
            return (
                <div>{moment(cellProps?.row?.original?.created_at).format('DD-MM-YYYY')}</div>
            )
        }
    },
    {
        Header: "Action",
        accessor: "action",
        className: "msupport_action text-center",
        Cell: cellProps => {
            const data = cellProps?.row?.original
            const isTimerRunning = isRunning && currentTaskId == data.id && localStorage.getItem("isTicketTime") == 'true';
            return (
                <div className="d-flex justify-content-center">
                    <button
                        className={`btn btn-sm ${isTimerRunning ? "btn-outline-danger" : "btn-outline-success"} me-1`}
                        title="Start/Stop Timer"
                        onClick={() => onStartTimer(data, isRunning)}
                        disabled={(isRunning && currentTaskId != data.id) || (isRunning && currentTaskId == data.id && localStorage.getItem("isTicketTime") != "true")}
                    >
                        <i className="fa fa-stopwatch"></i>
                    </button>
                    <a
                        onClick={() => onReply(cellProps?.row?.original)}
                        className="btn btn-sm btn-outline-secondary me-1"
                        title="Reply Ticket"
                    >
                        <i className="bi bi-reply-fill"></i>
                    </a>
                    <a
                        className="btn btn-sm btn-outline-primary me-1"
                        title="Info"
                        onClick={() => onAddHours(data?.id)}
                    >
                        <i className="bx bxs-timer fs-5"></i>
                    </a>
                </div>
            )
        },
    },
]

export const codeReviewColumn = (onChangeStatus, onStartTimer, isRunning, currentTaskId) => [
    {
        Header: "ID",
        accessor: "id",
        title: "ID",
        isInfoIcon: false,
        isShortIcon: true,
        className: "ss_id",
    },
    {
        Header: "File Path",
        accessor: "file_path",
        isInfoIcon: false,
        isShortIcon: true,
        className: "s_id",
        Cell: cellProps => {
            const filePath = (cellProps?.row?.original?.file_path)?.split('/')
            return (
                <div className="cursor-pointer">
                    {cellProps?.row?.original?.line_number} - {(cellProps?.row?.original?.file_path)}
                </div>
            )
        }
    },
    {
        Header: "Rule Message",
        accessor: "rule_message",
        isInfoIcon: false,
        isShortIcon: true,
        className: "s_id",
    },
    {
        Header: "Severity",
        accessor: "severity",
        isInfoIcon: false,
        isShortIcon: true,
        className: "s_id",
    },
    {
        Header: "Priority",
        accessor: "severity_label",
        isInfoIcon: false,
        isShortIcon: true,
        className: "s_id",
    },
    {
        Header: "Issue Category",
        accessor: "issue_category",
        isInfoIcon: false,
        isShortIcon: true,
        className: "s_id",
    },
    {
        Header: "Created At",
        title: "created at",
        accessor: "created_at",
        isInfoIcon: false,
        isShortIcon: true,
        className: "ss_id",
        Cell: cellProps => {
            return (
                <div>{moment(cellProps?.row?.original?.created_at).format('DD-MM-YYYY')}</div>
            )
        }
    },
    {
        Header: "Action",
        accessor: "action",
        className: "msupport_action text-center",
        Cell: cellProps => {  
            const data = cellProps?.row?.original
            const isTimerRunning = isRunning && currentTaskId == data.id && localStorage.getItem("code_time") == 'true';
            if (data?.status == 'fixed') {
                return '-'
            }
            return (
                <div className="d-flex justify-content-center">
                    {data?.status == "open" || data?.dev_status == 'query' ? (
                        <button
                            className={`btn btn-sm ${isTimerRunning ? "btn-outline-danger" : "btn-outline-success"} me-1`}
                            title="Start/Stop Timer"
                            onClick={() => onStartTimer(data, isRunning)}
                            disabled={(isRunning && currentTaskId != data.id) || (isRunning && currentTaskId == data.id && localStorage.getItem("code_time") != "true")}
                        >
                            <i className="fa fa-stopwatch"></i>
                        </button>
                    ) : null}
                    {data?.dev_status != "query" ? (
                        <a
                            className="btn btn-sm btn-outline-secondary me-1"
                            title="Queries"
                            onClick={() => onChangeStatus(cellProps?.row?.original?.id, 'query')}
                        >
                            <i className="fas fa-question-circle  text-lg"></i>
                        </a>
                    ) : null}
                    <a className="btn btn-sm btn-outline-primary me-1" title="Ready to Verify"
                        onClick={() => onChangeStatus(cellProps?.row?.original?.id, 'fixed')}
                    >
                        <i className="bi bi-check-lg icon-center"></i>
                    </a>
                </div>
            )
        },
    },
]


export const codeReviewQueriesColumn = (onChangeStatus) => [
    {
        Header: "ID",
        accessor: "id",
        title: "ID",
        isInfoIcon: false,
        isShortIcon: true,
        className: "ss_id",
    },
    {
        Header: "File Path",
        accessor: "file_path",
        isInfoIcon: false,
        isShortIcon: true,
        className: "s_id",
        Cell: cellProps => {
            const filePath = (cellProps?.row?.original?.file_path)?.split('/')
            return (
                <div className="cursor-pointer">
                    {cellProps?.row?.original?.line_number} - {(cellProps?.row?.original?.file_path)}
                </div>
            )
        }
    },
    // {
    //     Header: "Rule Id",
    //     accessor: "rule_id",
    //     isInfoIcon: false,
    //     isShortIcon: true,
    //     className: "s_id",
    // },
    {
        Header: "Rule Message",
        accessor: "rule_message",
        isInfoIcon: false,
        isShortIcon: true,
        className: "s_id",
    },
    {
        Header: "Severity",
        accessor: "severity",
        isInfoIcon: false,
        isShortIcon: true,
        className: "s_id",
    },
    {
        Header: "Priority",
        accessor: "severity_label",
        isInfoIcon: false,
        isShortIcon: true,
        className: "s_id",
    },
    {
        Header: "Issue Category",
        accessor: "issue_category",
        isInfoIcon: false,
        isShortIcon: true,
        className: "s_id",
    },
    {
        Header: "Created At",
        title: "created at",
        accessor: "created_at",
        isInfoIcon: false,
        isShortIcon: true,
        className: "ss_id",
        Cell: cellProps => {
            return (
                <div>{moment(cellProps?.row?.original?.created_at).format('DD-MM-YYYY')}</div>
            )
        }
    },
    {
        Header: "Action",
        accessor: "action",
        className: "msupport_action text-center",
        Cell: cellProps => {
            return (
                <div className="d-flex justify-content-center">
                    <a className="btn btn-sm btn-outline-primary me-1" title="Ignore"
                        onClick={() => onChangeStatus(cellProps?.row?.original?.id, 'ignored')}
                    >
                        <i className="bi bi-x-lg icon-center"></i>
                    </a>
                </div>
            )
        },
    },
]